const templateMap = {
    AL: 'street_name house_number',
    AO: 'street_name house_number',
    AR: 'street_name house_number',
    AT: 'street_name house_number',
    BA: 'street_name house_number',
    BE: 'street_name house_number',
    BG: 'street_name house_number',
    BI: 'street_name house_number',
    BN: 'house_number, street_name',
    BO: 'street_name house_number',
    BQ: 'street_name house_number',
    BR: 'street_name, house_number',
    BW: 'street_name house_number',
    BY: 'street_name house_number',
    CF: 'street_name house_number',
    CH: 'street_name house_number',
    CL: 'street_name house_number',
    CM: 'street_name house_number',
    CO: 'street_name house_number',
    CW: 'street_name house_number',
    CZ: 'street_name house_number',
    DE: 'street_name house_number',
    DK: 'street_name house_number',
    DO: 'street_name house_number',
    EC: 'street_name house_number',
    EE: 'street_name house_number',
    EH: 'street_name house_number',
    ER: 'street_name house_number',
    ES: 'street_name, house_number',
    ET: 'street_name house_number',
    FI: 'street_name house_number',
    FO: 'street_name house_number',
    GD: 'street_name house_number',
    GL: 'street_name house_number',
    GN: 'street_name house_number',
    GQ: 'street_name house_number',
    GR: 'street_name house_number',
    GT: 'street_name house_number',
    GW: 'street_name house_number',
    HN: 'street_name house_number',
    HR: 'street_name house_number',
    HT: 'street_name house_number',
    HU: 'street_name house_number',
    IR: 'street_name house_number',
    IS: 'street_name house_number',
    IT: 'street_name house_number',
    JO: 'street_name house_number',
    KG: 'street_name house_number',
    KI: 'street_name house_number',
    KM: 'street_name house_number',
    KW: 'street_name house_number',
    KZ: 'street_name house_number',
    LC: 'street_name house_number',
    LI: 'street_name house_number',
    LR: 'street_name house_number',
    LT: 'street_name house_number',
    LV: 'street_name house_number',
    LY: 'street_name house_number',
    MD: 'street_name house_number',
    ME: 'street_name house_number',
    MK: 'street_name house_number',
    ML: 'street_name house_number',
    MO: 'street_name house_number',
    MX: 'street_name house_number',
    MY: 'street_name house_number',
    MZ: 'street_name, house_number',
    NL: 'street_name house_number',
    NO: 'street_name house_number',
    PA: 'street_name house_number',
    PE: 'street_name house_number',
    PK: 'house_number - street_name',
    PL: 'street_name house_number',
    PT: 'street_name house_number',
    PY: 'street_name house_number',
    QA: 'street_name house_number',
    RO: 'street_name house_number',
    RS: 'street_name house_number',
    RU: 'street_name house_number',
    SB: 'street_name house_number',
    SD: 'street_name house_number',
    SE: 'street_name house_number',
    SI: 'street_name house_number',
    SJ: 'street_name house_number',
    SK: 'street_name house_number',
    SM: 'street_name house_number',
    SO: 'street_name house_number',
    SR: 'street_name house_number',
    SS: 'street_name house_number',
    ST: 'street_name house_number',
    SV: 'street_name house_number',
    SX: 'street_name house_number',
    SY: 'street_name house_number',
    TD: 'street_name house_number',
    TJ: 'street_name house_number',
    TR: 'street_name house_number',
    TZ: 'street_name house_number',
    UA: 'street_name house_number',
    UY: 'street_name house_number',
    VA: 'street_name house_number',
    VU: 'street_name house_number',
    WS: 'street_name house_number',
};

export default function cfwBuildAddress1( country: string, houseNumber: string, streetName: string ): string {
    const template = templateMap[ country ] ?? 'house_number street_name';

    return template.replace( 'house_number', houseNumber ).replace( 'street_name', streetName  );
}
